import { apiService } from '@/api/apiConfig';

import {
  Commitment,
  CommitmentsResponse,
  Invoice,
  InvoiceResponse,
  PaginatedResponse
} from '@/services/types/invoice.types';

const handleInvoiceError = (error: any): Error => {
  if (error.response?.data?.message) {
    return new Error(`Invoice operation failed: ${error.response.data.message}`);
  }
  return error instanceof Error ? error : new Error('Invoice operation failed');
};

export const invoiceService = {
  getInvoices: async (params: {
    page: number;
    limit: number;
    invoice_category: string | undefined;
    type: string | undefined;
    budget_id?: string | undefined;
    bank_account_id?: string | undefined;
    ac_id?: string | undefined;
    expense_category_id?: string | undefined;
    revenue_category_id?: string | undefined;
  }): Promise<PaginatedResponse<Invoice>> => {
    console.log('invoice_category', params.invoice_category);
    console.log('page', params.page);
    console.log('limit', params.limit);
    console.log('type', params.type);
    try {
      const response = await apiService.request<PaginatedResponse<Invoice>>({
        method: 'GET',
        url: '/invoice',
        params: {
          page: params.page,
          limit: params.limit,
          invoice_category: params.invoice_category,
          type: params.type,
          budget_id: params.budget_id,
          bank_account_id: params.bank_account_id,
          ac_id: params.ac_id,
          expense_category_id: params.expense_category_id,
          revenue_category_id: params.revenue_category_id
        }
      });
      return response;
    } catch (error) {
      throw handleInvoiceError(error);
    }
  },

  getInvoice: async (id: string): Promise<Invoice> => {
    try {
      const response = await apiService.request<InvoiceResponse>({
        method: 'GET',
        url: `/invoice/${id}`
      });
      return response.data;
    } catch (error) {
      throw handleInvoiceError(error);
    }
  },

  createInvoice: async (invoice: Invoice | FormData): Promise<Invoice> => {
    try {
      const response = await apiService.request<InvoiceResponse>({
        method: 'POST',
        url: '/invoice',
        data: invoice,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw handleInvoiceError(error);
    }
  },

  updateInvoice: async (id: string, invoice: Invoice | FormData): Promise<Invoice> => {
    try {
      const response = await apiService.request<InvoiceResponse>({
        method: 'PATCH',
        url: `/invoice/${id}`,
        data: invoice,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw handleInvoiceError(error);
    }
  },

  createDraftInvoice: async (invoice: Invoice | FormData): Promise<Invoice> => {
    try {
      const response = await apiService.request<InvoiceResponse>({
        method: 'POST',
        url: '/invoice/draft',
        data: invoice,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw handleInvoiceError(error);
    }
  },

  updateDraftInvoice: async (id: string, invoice: Invoice | FormData): Promise<Invoice> => {
    try {
      const response = await apiService.request<InvoiceResponse>({
        method: 'PATCH',
        url: `/invoice/draft/${id}`,
        data: invoice,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw handleInvoiceError(error);
    }
  },

  deleteInvoice: async (id: string): Promise<void> => {
    try {
      await apiService.request<void>({
        method: 'DELETE',
        url: `/invoice/${id}`
      });
    } catch (error) {
      throw handleInvoiceError(error);
    }
  },

  deleteDraftInvoice: async (id: string): Promise<void> => {
    try {
      await apiService.request<void>({
        method: 'DELETE',
        url: `/invoice/draft/${id}`
      });
    } catch (error) {
      throw handleInvoiceError(error);
    }
  },

  validateInvoice: async (id: string, paymentDate?: Date | null): Promise<Invoice> => {
    try {
      const response = await apiService.request<InvoiceResponse>({
        method: 'POST',
        url: `/invoice/${id}/validate`,
        data: {
          payment_date: paymentDate ? paymentDate.toISOString() : undefined
        }
      });
      return response.data;
    } catch (error) {
      throw handleInvoiceError(error);
    }
  },

  getCommitments: async (params: { date: string; budget_id?: string }): Promise<CommitmentsResponse> => {
    try {
      const response = await apiService.request<CommitmentsResponse>({
        method: 'GET',
        url: '/invoice/commitments',
        params: {
          date: params.date,
          budgetId: params.budget_id
        }
      });
      return response;
    } catch (error) {
      throw handleInvoiceError(error);
    }
  }
};
